import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedResidenceStudyLotApiService } from './residence-study-lot-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class ResidenceStudyLotApiService extends GeneratedResidenceStudyLotApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
